import classnames from 'classnames'
import checkedIcon from '../../images/management/intakeForms/checked.png'
import './CheckBox.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const CheckBox = ({ label, isChecked, setIsChecked, className }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
  <label
    className={classnames('container-checkBox', { [className]: className })}
    htmlFor={`checkbox${label}`}
    onClick={setIsChecked}>
    <input type='checkbox' checked={isChecked} name={`checkbox${label}`} />
    <span className='checkmark' />
    <span className='checkboxTitle'>{label}</span>
    {isChecked ?
      <img src={checkedIcon} className='checked-icon' alt='Checked' />
    : null}
  </label>
)
